module.exports = __webpack_public_path__ + "img/logo24.321eb0da.png";